import type { RequestFunction } from "@kanda-libs/openapi-io-ts-runtime";
import * as schemas from "../components/schemas";

export type ExportJobPayoutsRequestParameters = {
  dryrun?: boolean;
  payout?: "set_payout_pending" | "set_paid";
};

export const exportJobPayoutsOperation = {
  path: "/api/job/all/export-payouts",
  method: "post",
  responses: {
    "200": { _tag: "JsonResponse", decoder: schemas.ExportCSV },
    default: { _tag: "JsonResponse", decoder: schemas.Error },
  },
  parameters: [
    {
      _tag: "FormParameter",
      explode: true,
      in: "query",
      name: "dryrun",
      defaultValue: true,
    },
    {
      _tag: "FormParameter",
      explode: true,
      in: "query",
      name: "payout",
    },
  ],
  requestDefaultHeaders: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  body: {
    _tag: "JsonBody",
  },
} as const;

export type ExportJobPayoutsRequestFunction = RequestFunction<
  { params: ExportJobPayoutsRequestParameters; body: Array<string> },
  schemas.ExportCSV
>;
